import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.PARAMETERS_MENU;

const ParametersMenuLink: Array<LinkItemProps> = [
  {
    name: 'Motif Remplacement Carte',
    link: URL.REASON_CARD_REPLACEMENT,
    level: 3,
  },
  {
    name: 'Motif Arrêt de Renouvel. Automatique de Cartes',
    link: URL.REASON_STOPPING_AUTOMATIC_CARD_RENEWAL,
    level: 3,
  },
  {
    name: 'Motif Statut Carte',
    link: URL.REASON_CARD_STATUS,
    level: 3,
  },
  {
    name: 'Motif Statut Client',
    link: URL.REASON_CUSTOMER_STATUS,
    level: 3,
  },

];

export default ParametersMenuLink;
